import React from 'react'
import { motion } from 'framer-motion';
import payment from "../assets/creators/payment.webp"
import { useNavigate } from 'react-router-dom';



const PayLandingPage = () => {
    // State to control hover
    const [isHovered, setIsHovered] = React.useState(false);
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col md:flex-row items-center justify-between px-6 md:px-16 py-12 bg-white"
        style={{fontFamily:"Gilroy-Medium"}}
        >
           
                        <motion.div
                            initial={{ x: -60, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 0.7, ease: 'easeOut' }}
                            className="w-full md:w-1/2 flex flex-col items-start justify-center space-y-6"
                        >
                            <span className="bg-pink-100 text-pink-600 text-xs font-semibold px-3 py-1 rounded-full mb-2">
                                Pay Creators &rarr;
                            </span>
                            <motion.h1
                                className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight"
                                animate={isHovered ? { scale: 1.05, color: "#db2777" } : { scale: 1, color: "#111827" }}
                                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            >
                                Simplify Your Vendor<br />Payments With Open
                            </motion.h1>
                            <motion.p
                                className="text-gray-500 text-base md:text-lg mt-2"
                                animate={isHovered ? { scale: 1.03, color: "#be185d" } : { scale: 1, color: "#6b7280" }}
                                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            >
                                Handle Accounts Payable like a PRO: Create bills and pay vendors on the same platform, saving hundreds of hours on data entry and vendor payment reconciliation.
                            </motion.p>
                            <div className="flex flex-row gap-4 mt-6">
                                <motion.button
                                    className="bg-pink-600 hover:bg-pink-700 text-white font-semibold px-4 py-2 rounded-full flex items-center transition"
                                    animate={isHovered ? { scale: 1.07, boxShadow: "0 4px 24px #db277755" } : { scale: 1, boxShadow: "0 0px 0px transparent" }}
                                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    onClick={()=>navigate("/creatorpay")}
                                >
                                    Get Started <span className="ml-2">&rarr;</span>
                                </motion.button>
                                <motion.button
                                    className="bg-white border border-gray-300 hover:bg-gray-100 text-gray-900 font-semibold px-4 py-2 rounded-full flex items-center transition"
                                    animate={isHovered ? { scale: 1.05, boxShadow: "0 4px 16px #be185d33" } : { scale: 1, boxShadow: "0 0px 0px transparent" }}
                                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                >
                                    Explore More <span className="ml-2">&rarr;</span>
                                </motion.button>
                            </div>
                        </motion.div>

                        {/* Right Side - Image */}
            <motion.div
                initial={{ x: 60, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.7, ease: 'easeOut', delay: 0.2 }}
                className="w-full md:w-1/2 flex items-center justify-center mt-10 md:mt-0"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className="w-full max-w-xl">
                    <div className="aspect-w-16 aspect-h-10 flex items-center justify-center">
                        <motion.img
                            src={payment}
                            alt="Payment"
                            animate={isHovered ? { scale: 1.07, rotate: 2 } : { scale: 1, rotate: 0 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            style={{ willChange: "transform" }}
                        />
                    </div>
                </div>
            </motion.div>
        </div>
    );
};



export default PayLandingPage;